//@flow
import { DistrictOptions } from "../../Constants/GlobalVariables/DistrictOptions";

export const determineCityAndDistrictOptionsFromProps = (props: Object) => {
    const city = props.formElements.city;
    const districtOptions = city && DistrictOptions.filter((option) => {
        return option.city === city;
    })[0];

    return {
        selectedCity: city || "",
        districtOptions: districtOptions ? districtOptions.districtOptions : []
    }
};



// WEBPACK FOOTER //
// ./src/Utilities/Helpers/OptionsHelpers.js